module.exports = __webpack_public_path__ + "img/bottom-show.88d52b4c.png";